import type { FC, ReactElement } from 'react'

type PropsChildren = ReactElement

type SlotProps<Children extends PropsChildren> = {
  children: Children
}

type SlotComponent<Children extends PropsChildren> = FC<SlotProps<Children>>

export function getSlot(children: ReactElement[] | ReactElement | undefined, slot: SlotComponent<PropsChildren>): ReactElement | undefined {
  if (Array.isArray(children)) {
    return children.find((child) => {
      return child.type === slot
    })
  }
  if (children?.type === slot) {
    return children
  }
  return undefined
}
